import React, { useState, useEffect } from 'react';
import styled from 'styled-components/macro';
import LoadingIndicator from '../../LoadingIndicator';
import { fetchData } from '../../GtfsFeeds';
import ListHeader from './ListHeader';
import Row from './Row';
import { trackFontHeavy } from '../../styles/Font';

const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  width: 100%;
  margin: 50px 0;
`;

const NothingToDisplay = styled.div`
  ${trackFontHeavy}
  text-align: center;
`;

function List() {
  const [cutomerList, setCutomerList] = useState(null);
  useEffect(() => {
    fetchData().then(v => setCutomerList(v));
    return () => {};
  }, []);

  return (
    <ListContainer>
      {cutomerList && cutomerList.length !== 0 && (
        <>
          <ListHeader />
          {cutomerList.map(agency => (
            <Row agencyInfo={agency} key={agency[0].agency_id} />
          ))}
        </>
      )}
      {cutomerList && cutomerList.length === 0 && (
        <NothingToDisplay>
          No customers have elected to publish their GTFS feeds at this time. <br /> <br /> Check
          back soon!
        </NothingToDisplay>
      )}
      {!cutomerList && <LoadingIndicator />}
    </ListContainer>
  );
}

export default List;
